module.exports = __webpack_public_path__ + "media/images/icons/icon_search_white_transparent-e7ec39c77a658ed129d6cea014f63935.svg";